import React, { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';
import './Autocomplete.scss';
import Suggestions from './Suggestions';

const Autocomplete = ({
    id,
    type,
    className,
    value,
    floating,
    valid = true,
    validationMessage,
    label,
    placeholder,
    autoComplete,
    suggestions,
    onSuggestionSelect,
    forbiddenCharacters,
    maxLength,
    mask,
    inputMode,
    readonly,
    disabled,
    onChange,
    onFocus,
    onBlur,
    onClick,
    onKeyDown
}) => {
    const [isFloating, setIsFloating] = useState(value && value.length > 0);
    const [isSuggestionVisible, setIsSuggestionVisible] = useState(false);

    useEffect(() => {
        if (suggestions && suggestions.length > 0) {
            setIsSuggestionVisible(true);
        }
    }, [suggestions]);

    useEffect(() => {
        if (value && value.length > 0) {
            setIsFloating(true);
        }
    }, [value]);

    const onInputChange = (e) => {
        let hasForbiddenChar = false;
        if (forbiddenCharacters && e.target.value) {
            hasForbiddenChar = forbiddenCharacters.some((c) => {
                if (e.target.value.indexOf(c) > -1) {
                    return true;
                }
            });
        }
        if (hasForbiddenChar) {
            return;
        }
        onChange && onChange(e);
    };

    const onInputKeyDown = (e) => {
        if (e.keyCode === 9) {
            // Tab
            setIsSuggestionVisible(false);
        }
        onKeyDown && onKeyDown(e);
    };

    return (
        <div
            id={`${id}--container`}
            className={`autocomplete ${className || ''} ${valid ? '' : 'error'} ${
                floating ? 'floating-label' : ''
            } ${floating && isFloating ? 'floating' : ''} ${disabled ? 'disabled' : ''}`}
        >
            {!floating && label && (
                <label htmlFor={id} className="autocomplete-label">
                    {label}
                </label>
            )}
            {!mask && (
                <input
                    id={id}
                    type={type || 'text'}
                    value={value}
                    onChange={(e) => onInputChange(e)}
                    onFocus={(e) => {
                        setIsFloating(true);
                        onFocus && onFocus(e);
                    }}
                    onBlur={(e) => {
                        setIsFloating(e.target.value && e.target.value.length > 0);
                        onBlur && onBlur(e);
                    }}
                    onClick={(e) => onClick && onClick(e)}
                    onKeyDown={(e) => onInputKeyDown(e)}
                    placeholder={placeholder}
                    autoComplete={autoComplete || 'off'} //--TODO: disable for Chrome
                    maxLength={maxLength}
                    inputMode={inputMode || 'text'}
                    readOnly={readonly || false}
                    disabled={disabled ? true : false}
                    data-testid={id}
                />
            )}
            {mask && (
                <InputMask
                    id={id}
                    mask={mask}
                    value={value}
                    onChange={(e) => onInputChange(e)}
                    onFocus={(e) => {
                        setIsFloating(true);
                        onFocus && onFocus(e);
                    }}
                    onBlur={(e) => {
                        setIsFloating(e.target.value && e.target.value.length > 0);
                        onBlur && onBlur(e);
                    }}
                    onClick={(e) => onClick && onClick(e)}
                    onKeyDown={(e) => onInputKeyDown(e)}
                ></InputMask>
            )}
            {suggestions && isSuggestionVisible && (
                <Suggestions
                    items={suggestions}
                    onClick={(suggestionId) => {
                        onSuggestionSelect(suggestionId);
                        setIsSuggestionVisible(false);
                    }}
                />
            )}
            {floating && label && <p className="autocomplete-label">{label}</p>}
            {!valid && !disabled && (
                <p className="autocomplete-error">{validationMessage || 'To pole jest wymagane'}</p>
            )}
        </div>
    );
};

export default Autocomplete;
